import type { U2000ReactFlowContextMenuItem } from '../../u2000Core/components/dialog/U2000ReactFlowDialog';

/** En-tête de section (non cliquable) pour le menu contextuel graphe U3141. */
export function u3141GraphContextMenuSectionHeader(
  key: string,
  label: string,
): U2000ReactFlowContextMenuItem {
  return { key, label, sectionHeader: true };
}

/** Regroupe des entrées sous un titre de section (UX menu contextuel). */
export function u3141AppendGraphContextMenuSection(
  target: U2000ReactFlowContextMenuItem[],
  headerKey: string,
  headerLabel: string,
  sectionItems: U2000ReactFlowContextMenuItem[],
): void {
  if (sectionItems.length === 0) return;
  target.push(u3141GraphContextMenuSectionHeader(headerKey, headerLabel));
  target.push(...sectionItems);
}
